import Component from 'component';
import _array from 'lodash/array';
import _template from 'lodash/template';
import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';
import Modal from './ModalProjGallery';
import filtersTpl from '../templates/proj-gallery/filters';
import itemCardTpl from '../templates/proj-gallery/item-card';

class ProjectsGalleryListing extends Component {
  constructor(el) {
    super(el);

    this.renderItems();
  }

  setupDefaults() {
    this.galleryId = this.$el.data('galleryId');
    this.displayingItems = 6;
    this.preloadItem = decodeURIComponent(window.location.hash.substring(1));

    this.dom = {
      $itemList: this.$el.find('.proj-gallery__items'),
      $filters: this.$el.find('.proj-gallery__filters'),
      $filterList: this.$el.find('.proj-gallery__filter-list'),
      $loading: this.$el.find('.proj-gallery__loading'),
      $loadMore: this.$el.find('.proj-gallery__load-more')
    };
  }

  addListeners() {
    this.dom.$loadMore.on('click', () => :: this.displayItems(true));
  }

  getResults() {
    return $.ajax({
      url: this.$el.data('endpoint'),
      data: { galleryId: this.galleryId }
    });
  }

  async renderItems() {
    const results = await this.getResults();
    const { products } = results.response;

    this.dom.$loading.hide();

    let filters = [];
    const productsByCategory = {};

    products.forEach((product, index) => {
      const categoryNames = [];
      //we need to clone the product because other code will change its properties per category
      const clonedProduct = JSON.parse(JSON.stringify(product));
      for(let i = 0; i < clonedProduct.categories.length; i++) {
        const categoryName = clonedProduct.categories[i];
        categoryNames.push(categoryName);
        if (productsByCategory[categoryName]) {
          productsByCategory[categoryName].push(clonedProduct);
        } else {
          productsByCategory[categoryName] = [clonedProduct];
        }
      }
      clonedProduct.hashedCategories = categoryNames;
      filters = _array.union(filters, clonedProduct.categories);
      this.dom.$itemList.append(
        _template(itemCardTpl)({ ...clonedProduct, index })
      );
    });

    // Add masonry
    this.$itemListMsnry = new Masonry(this.dom.$itemList[0], {
      itemSelector:
        '.proj-gallery-item__card--loaded:not(.proj-gallery-item__card--filtered)'
    });

    imagesLoaded(this.dom.$itemList, () => {
      this.$itemListMsnry.layout();
    });

    this.dom.$filters.html(_template(filtersTpl)({ filters }));
    this.displayItems();
    this.attachFilterEvents();

    this.$el.on('click', '.proj-gallery-item__card-inner', e => {
      const slide = $(e.currentTarget).data('guid');
      const tmp = $('<div/>');
      const model = new Modal(tmp, productsByCategory, slide);
      tmp.trigger('click');
    });

    if (this.preloadItem) {
      this.dom.$itemList
        .find(`[data-guid="${this.preloadItem}"]`)
        .trigger('click');
    }
  }

  attachFilterEvents() {
    this.dom.$filters
      .find('.proj-gallery__filter-item')
      .on('click', :: this.toggleFilter);
    this.dom.$filters
      .find('.proj-gallery__filter-toggle')
      .on('click', :: this.toggleFilterDropdown);
    this.dom.$filters
      .find('.proj-gallery__filter-dropdown__apply')
      .on('click', :: this.toggleFilterDropdown);
  }

  toggleFilter(e) {
    e.preventDefault();

    const $filter = $(e.currentTarget);
    const $filters = this.dom.$filters.find('.proj-gallery__filter-item');
    const $filterLabel = this.dom.$filters.find(
      '.proj-gallery__filter-toggle__label'
    );
    $filter.toggleClass('proj-gallery__filter-item--active');

    const activeFilters = [];
    this.dom.$filters
      .find('.proj-gallery__filter-item--active')
      .each((index, filter) => {
        activeFilters.push($(filter).data('filter'));
      });

    if (!activeFilters.length) {
      $filter.toggleClass('proj-gallery__filter-item--active');
      return;
    }

    if (activeFilters.length < $filters.length) {
      $filterLabel.html(activeFilters.join(', '));
    } else {
      $filterLabel.html('All');
    }

    const hasCategory = category => activeFilters.indexOf(category) >= 0;
    this.dom.$itemList
      .find('.proj-gallery-item__card-inner')
      .each((index, item) => {
        if (
          $(item)
            .data('categories')
            .split(',')
            .some(hasCategory)
        ) {
          $(item)
            .parent()
            .removeClass('proj-gallery-item__card--filtered');
        } else {
          $(item)
            .parent()
            .addClass('proj-gallery-item__card--filtered');
        }
      });

    this.displayItems();
  }

  toggleFilterDropdown(e) {
    e.preventDefault();

    const $dropdown = this.dom.$filters.find('.proj-gallery__filter-dropdown');
    $dropdown.toggleClass('proj-gallery__filter-dropdown--open');
  }

  displayItems(loadMore) {
    if (loadMore) {
      this.displayingItems += 18;
    }

    this.dom.$itemList
      .find('.proj-gallery-item__card')
      .removeClass('proj-gallery-item__card--loaded');

    if (
      this.displayingItems >=
      this.dom.$itemList.find(
        '.proj-gallery-item__card:not(.proj-gallery-item__card--filtered)'
      ).length
    ) {
      this.dom.$loadMore.hide();
    } else {
      this.dom.$loadMore.show();
    }

    const nonFilteredItems = this.dom.$itemList.find(
      '.proj-gallery-item__card:not(.proj-gallery-item__card--filtered)'
    );
    nonFilteredItems
      .slice(0, this.displayingItems)
      .addClass('proj-gallery-item__card--loaded');

    this.$itemListMsnry.reloadItems();
    this.$itemListMsnry.layout();
  }
}

export default ProjectsGalleryListing;



// WEBPACK FOOTER //
// ./src/bb/js/components/ProjectsGalleryListing.js